(function() {
    'use strict';

    var hints = document.querySelectorAll('[data-input-hint]');

    if (!hints) {
        return;
    }

    for (var i = 0; i < hints.length; i++) {
        var hint = hints[i];

        hint.addEventListener('blur', function() {
            var cleanedValue = hint.value.replace(/\s+/g, ''); // Remove spaces from the string
            var inputValue = parseFloat(cleanedValue);
            var formField = hint.closest('.form-group');

            if (!isNaN(inputValue) && inputValue < 100) {
                formField.classList.add('form-group--hint');
            } else {
                formField.classList.remove('form-group--hint');
            }
        });
    }
}());
